import { isSystem } from '@umu/ukit-lang';
import { API_TYPE } from '@umu/umu-fetch';
import { IAdapterConfig } from './types';

export async function allSettledCompat<T>(promises: Promise<T>[]): Promise<void> {
    try {
        await Promise.allSettled(promises);
    } catch (error) {
        // 降级处理：Promise.allSettled 不存在时使用 Promise.all
        await Promise.all(promises.map((p) => p.catch(() => {})));
    }
}

export function getUserInfo() {
    return (
        window.pageData?.userInfo ||
        window.pageData?.user_info ||
        window.pageData?.data?.userInfo ||
        window.pageData?.data?.user_info
    );
}

export function getBesChannelsUserFlag() {
    const { wx_id: UnionID, open_id: OpenID, phone: PhoneNumber, email: Email } = getUserInfo() || {};
    const userFlag = { UnionID, OpenID, PhoneNumber, Email };
    return Object.keys(userFlag).reduce(
        (acc, cur) =>
            userFlag[cur as keyof typeof userFlag] ? { ...acc, [cur]: userFlag[cur as keyof typeof userFlag] } : acc,
        {},
    );
}

export const ADAPTER_CONFIG: Record<string, IAdapterConfig> = {
    besChannels: {
        enabled: isSystem('cn'),
        config: {
            orgId: 'org9c62775d12ec259ade7473e6b65f951c',
            scriptUrl: 'https://cdn.beschannels.com/js-sdk/collect-0.0.5.min.js',
            eventProps: { source: 'web' },
            userFlag: getBesChannelsUserFlag(),
            initOptions: {
                page_view_auto: true,
                element_click_auto: false,
                events: ['BUTTON', 'input[type="submit"]', 'IMG', 'A'],
            },
            desReportAPI: {
                url: '/uapi/v1/des/report',
                type: API_TYPE.POST,
            },
        },
    },
};
